import { useSetAtom } from "jotai";
import { checkAuthAtom, logoutAtom } from "../../store/actions.js";

// Auth Action Hooks
export const useAuthActions = () => {
  const checkAuth = useSetAtom(checkAuthAtom);
  const logout = useSetAtom(logoutAtom);

  return {
    checkAuth,
    logout,
  };
};
